// extracted by mini-css-extract-plugin
export default {"root":"ProjectDrawdowns_root__eKDNQ","details":"ProjectDrawdowns_details__Q23XF","block":"ProjectDrawdowns_block__3ZbDh"};